import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const invitationCode = searchParams.get('code');
  const { language, setAppLanguage, t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      
      // Detect active section based on scroll position
      const sections = ["home", "details", "dresscode", "story", "gallery", "guest-photos", "gifts", "buenos-aires"];
      
      const scrollPosition = window.scrollY + 100;
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const currentPath = location.pathname;
    const basePath = currentPath.startsWith('/es') ? '/es' : '/';
    
    if (currentPath === basePath || currentPath === basePath + '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setActiveSection(sectionId);
      }
    }
    setIsMobileMenuOpen(false);
  };

  const handleRSVPClick = () => {
    const currentPath = location.pathname;
    const basePath = currentPath.startsWith('/es') ? '/es' : '';
    
    if (invitationCode) {
      navigate(`${basePath}/rsvp?code=${invitationCode}`);
    } else {
      navigate(`${basePath}/rsvp`);
    }
    setIsMobileMenuOpen(false);
  };

  const navItems = [
    { id: 'home', label: t('navigation.home'), href: '/' },
    { id: 'details', label: t('navigation.details'), href: '/#details' },
    { id: 'dresscode', label: t('navigation.dressCode'), href: '/#dresscode' },
    { id: 'gallery', label: t('navigation.gallery'), href: '/#gallery' },
    { id: 'guest-photos', label: t('navigation.guestPhotos'), href: '/#guest-photos' },
    { id: "gifts", label: t("navigation.gifts"), href: "/#gifts" },    { id: 'buenos-aires', label: t('navigation.buenosAires'), href: '/#buenos-aires' },
  ];

  const toggleLanguage = () => {
    const newLanguage = language === 'en' ? 'es' : 'en';
    setAppLanguage(newLanguage);
  };

  return (
    <nav className={`navbar navbar-expand-lg fixed-top ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container">
        <Link className="navbar-brand fw-bold" to={language === 'es' ? '/es' : '/'}>
          C & E
        </Link>
        
        <button 
          className="navbar-toggler" 
          type="button" 
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className={`collapse navbar-collapse ${isMobileMenuOpen ? 'show' : ''}`}>
          <ul className="navbar-nav ms-auto">
            {navItems.map((item) => (
              <li key={item.id} className="nav-item">
                {item.href.startsWith('/#') ? (
                  <button 
                    className={`nav-link ${activeSection === item.id ? 'active' : ''}`}
                    onClick={() => scrollToSection(item.id)}
                  >
                    {item.label}
                  </button>
                ) : (
                  <Link 
                    className={`nav-link ${activeSection === item.id ? 'active' : ''}`} 
                    to={item.href}
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            ))}
            
            <li className="nav-item">
              <button 
                className="nav-link btn btn-primary"
                onClick={handleRSVPClick}
              >
                {t('navigation.rsvp')}
              </button>
            </li>
            
            {/* Language Switcher */}
            <li className="nav-item">
              <button 
                className="nav-link language-switcher"
                onClick={toggleLanguage}
                title={language === 'en' ? 'Cambiar a Español' : 'Switch to English'}
              >
                <i className={`fas fa-globe me-1`}></i>
                {language === 'en' ? 'ES' : 'EN'}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
